export default {
  getSelectedWorkTask(state) {
    return state.selectedWorkTask
  }
}
